import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { ErrorComponent } from 'app/popup/error.component';
import { AlertComponent } from 'app/popup/alert.component';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { StatusService } from 'app/services/status.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-list-status',
  templateUrl: './list-status.component.html',
  styleUrls: ['./list-status.component.css']
})
export class ListStatusComponent implements OnInit {

  statuses: any = [];
  isRemove = false;
  removeRef: any;
  page = 1;
  lblHeading = '';
  showNum: number = 10;

  popoverTitle = 'Delete Status';
  popoverMessage = 'Are you sure you want to delete Status?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';

  public isLoading = false;
  isEmpty: boolean = false;
  message = "Loading Statuses...";

  constructor(private statusService: StatusService,
     public utility: UtilityServiceService,private toastr: ToastrService) { }

  ngOnInit() {
    this.onChangeHeandig();    
    this.reload();
    this.utility.direction = true;    
    this.utility.page = 1;
  }

  reload() {
    this.isLoading = true;
    this.statusService.getAll().subscribe(result => {
      this.statuses = result;
      this.utility.onSort(0);      
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
    });
  }

  onDelete(id: any) {
    this.statusService.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Status', message: `Status ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastr.success(`Status ${this.removeRef.code} deleted.`,'Delete Status');
      if (result != null) {
        this.onNo();
        this.reload();
        this.utility.direction = true; 
      }
      this.onChangeHeandig();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Status', message: `Status ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastr.error(`Status ${this.removeRef.code} was not deleted.`,'Delete Status');
    });
  }

  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Status <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeandig(false);
    this.isRemove = true;
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Statuses' : 'Delete Status';
  }

}
